<template>
  <!-- [sc-49210] Dettaglio di una riga di tabella (clic sulla riga):
       mostra i campi delle colonne nascoste (.col-secondary). -->
  <VueFinalModal
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    classes="row-details-modal"
    content-class="row-details-modal__content"
  >
    <button
      type="button"
      class="row-details-modal__close"
      @click="$emit('update:modelValue', false)"
      aria-label="Chiudi"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
    <h3 class="row-details-modal__title">{{ title }}</h3>
    <dl class="row-details">
      <slot />
    </dl>
  </VueFinalModal>
</template>

<script>
export default {
  name: "RowDetailsModal",
  props: {
    modelValue: { type: Boolean, default: false },
    title: { type: String, default: "" },
  },
  emits: ["update:modelValue"],
};
</script>

<style>
.row-details-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.row-details-modal__content {
  position: relative;
  width: min(520px, 92vw);
  max-height: 85vh;
  overflow-y: auto;
  margin: auto;
  padding: 24px 20px 20px;
  /* come le altre modali del CRM (es. dettaglio fuori magazzino) */
  border-radius: 0.25rem;
  background: var(--modal-bg);
  color: var(--modal-text);
  border: 1px solid var(--modal-border);
  box-shadow: var(--modal-shadow);
  box-sizing: border-box;
}

.row-details-modal__close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  font-size: 18px;
  cursor: pointer;
}

.row-details-modal__close:hover {
  background: rgba(127, 127, 127, 0.15);
}

.row-details-modal__title {
  margin: 0 40px 16px 0;
  font-size: 1.1rem;
  overflow-wrap: anywhere;
}

/* Etichetta sopra, valore sotto: va bene a ogni larghezza */
.row-details {
  display: grid;
  gap: 12px;
  margin: 0;
}

.row-details dt {
  font-size: 12px;
  font-weight: 700;
  color: var(--modal-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.row-details dd {
  margin: 2px 0 0;
  font-size: 14px;
  overflow-wrap: anywhere;
}

.row-details dd img {
  max-width: 120px;
  height: auto;
  border-radius: 8px;
}
</style>
